// SPDX-License-Identifier: Apache-2.0
//
// Built-in English messages of the layer 2 components: `<component>.<key>`.
// Every key here must exist in ko.js too (layer2/test/catalog.test.js).

export default {
  common: {
    loading: 'Loading'
  },
  alert: {
    dismiss: 'Dismiss'
  },
  breadcrumb: {
    label: 'Breadcrumb'
  },
  carousel: {
    carousel: 'carousel',
    slide: 'slide',
    position: '{index} of {total}',
    goTo: 'Go to slide {index}',
    prev: 'Previous slide',
    next: 'Next slide',
    pause: 'Pause',
    play: 'Play'
  },
  chart: {
    label: 'Chart',
    legend: 'Legend',
    point: '{series}, {label}: {value}'
  },
  confirm: {
    ok: 'OK',
    cancel: 'Cancel'
  },
  datePicker: {
    placeholder: 'YYYY-MM-DD'
  },
  dateRangePicker: {
    start: 'Start date',
    end: 'End date'
  },
  emptyState: {
    title: 'No data'
  },
  grid: {
    select: 'Select',
    selectAll: 'Select all rows on this page',
    selectRow: 'Select row {index}',
    range: '{from}–{to} of {total}'
  },
  modal: {
    close: 'Close'
  },
  numberInput: {
    decrement: 'Decrease',
    increment: 'Increase'
  },
  pagination: {
    label: 'Pagination',
    previous: 'Previous page',
    next: 'Next page',
    page: 'Page {page}'
  },
  passwordInput: {
    show: 'Show',
    hide: 'Hide'
  },
  rating: {
    label: 'Rating',
    value: '{value} of {max}'
  },
  searchInput: {
    label: 'Search',
    placeholder: 'Search',
    clear: 'Clear search'
  },
  sparkline: {
    summary: 'From {first} to {last}, low {min}, high {max}',
    empty: 'No data'
  },
  splitButton: {
    more: 'More options'
  },
  statCard: {
    up: 'Up',
    down: 'Down'
  },
  stepper: {
    complete: 'Completed'
  },
  tag: {
    remove: 'Remove {label}'
  },
  timePicker: {
    placeholder: 'HH:MM'
  },
  toast: {
    dismiss: 'Dismiss',
    region: 'Notifications'
  }
};
